import { createSelector } from "reselect";
import { initialState } from "./reducer";

const reducerState = (state) => state.OrderDetail || initialState;

const makeOrderDetailSelectField = (field) =>
  createSelector(reducerState, (orderDetailState) => orderDetailState[field]);

const orderStatusList = () =>
  createSelector(() => {
    const orderStatus = [
      { label: "Confirmed", value: "1", color: "light" },
      { label: "Dispatched", value: "2", color: "gray" },
      { label: "Delivered", value: "3", color: "green" },
      { label: "Cancelled", value: "4", color: "red" },
    ];
    return orderStatus;
  });

export { reducerState, makeOrderDetailSelectField, orderStatusList };
